export const APPROVE_FILE_REQUEST = 'APPROVE_FILE_REQUEST';

export enum FileStatus {
  EDIT = 'edit',
  READ_ONLY = 'read_only',
  LOADING = 'loading',
  TEMPLATE = 'template',
}

/**
 * Interface for the fileState slice of the state
 */
export interface FileStateInterface {
  fileStatus: FileStatus;
  fileHasBeenEdited: boolean;
}

export interface ApproveFileRequestActionInterface {
  [extraProps: string]: unknown;
  type: typeof APPROVE_FILE_REQUEST;
  payload: {
    id: string;
  };
}
